"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Network = void 0;
const axios_1 = __importDefault(require("axios"));
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const dataRetrive_1 = require("../dataRetrive");
const encrypt_1 = require("../encrypt");
const Error_1 = require("../error/Error");
const NetworkHelper_1 = require("./NetworkHelper");
const Tools_1 = require("./Tools");
var Network;
(function (Network) {
    const noBodyMethod = ["GET", "DELETE"];
    function getRequiredTokenInfo(params) {
        const { authType, signature } = params;
        if ((!authType || authType === NetworkHelper_1.AuthType.None) && !signature) {
            // 不需要签名
            return (0, rxjs_1.of)({});
        }
        else if (authType === NetworkHelper_1.AuthType.Access && !signature) {
            // 只需要AccessToken
            return (0, dataRetrive_1.getTradeDependencyInstance)()
                .getAccessToken()
                .pipe((0, operators_1.map)((token) => {
                const tokenInfo = {
                    awsToken: token,
                };
                return tokenInfo;
            }));
        }
        else {
            // 需要TradeToken
            return (0, dataRetrive_1.getTradeDependencyInstance)()
                .getTradingToken()
                .pipe((0, operators_1.map)((tokenInfo) => {
                if (!tokenInfo) {
                    throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.TradeUnAuthorized, "trade_unAuthorized");
                }
                return tokenInfo;
            }));
        }
    }
    function configParams(config, params) {
        const { needCommonParams = true } = params;
        let fullParams = {};
        if (noBodyMethod.includes(config.method || "") && params.data) {
            fullParams = Object.assign({}, params.data);
        }
        const queryString = params.url.split("?")[1];
        if (needCommonParams && (!queryString || !queryString.includes("client_id="))) {
            const commonParam = (0, dataRetrive_1.getTradeDependencyInstance)().getRunTimeHost().commonParam || {};
            fullParams = Object.assign(Object.assign({}, commonParam), fullParams);
        }
        config.params = fullParams;
        return config;
    }
    function toAuthTokenTypes(authType) {
        switch (authType) {
            case NetworkHelper_1.AuthType.Access:
                return ["access"];
            case NetworkHelper_1.AuthType.Spot:
                return ["spot"];
            case NetworkHelper_1.AuthType.Trader:
                return ["trader"];
            case NetworkHelper_1.AuthType.AccessAndSpot:
                return ["access", "spot"];
            case NetworkHelper_1.AuthType.AccessAndTrader:
                return ["access", "trader"];
            case NetworkHelper_1.AuthType.FullToken:
                return ["access", "spot", "swap_binance", "trader"];
            default:
                return [];
        }
    }
    function configAuthorization(config, params, tokenInfo) {
        const { needBearer = true, authType } = params;
        if (!authType || authType === NetworkHelper_1.AuthType.None) {
            return config;
        }
        let authorization = "";
        if (authType === NetworkHelper_1.AuthType.Access) {
            authorization = tokenInfo.awsToken;
        }
        else if (authType === NetworkHelper_1.AuthType.Spot) {
            authorization = tokenInfo.tradingToken || "";
        }
        else if (authType === NetworkHelper_1.AuthType.Trader) {
            authorization = tokenInfo.traderToken || "";
        }
        else {
            // 多token固定格式： access|spot|swap_binance|trader
            const tokenTypes = toAuthTokenTypes(authType);
            authorization = `${
            // 1. access
            tokenTypes.includes("access") ? tokenInfo.awsToken : ""}|${
            // 2. spot
            tokenTypes.includes("spot") ? tokenInfo.tradingToken || "" : ""}|${
            // 3. swap_binance
            tokenTypes.includes("swap_binance") ? tokenInfo.swapToken || "" : ""}|${
            // 4. trader
            tokenTypes.includes("trader") ? tokenInfo.traderToken || "" : ""}`;
        }
        if (needBearer) {
            authorization = `Bearer ${authorization}`;
        }
        config.headers["Authorization"] = authorization;
        return config;
    }
    function configSignature(config, params, tokenInfo, body) {
        if (!params.signature) {
            return config;
        }
        const authTokenTypes = toAuthTokenTypes(params.authType);
        let secret = tokenInfo.apiSecret;
        if (authTokenTypes.includes("spot")) {
            secret = tokenInfo.apiSecret;
        }
        else if (authTokenTypes.includes("trader")) {
            secret = tokenInfo.traderApiSecret;
        }
        else if (authTokenTypes.includes("swap_binance")) {
            secret = tokenInfo.swapApiSecret;
        }
        const timestamp = new Date().getTime() - (0, dataRetrive_1.getTradeDependencyInstance)().timestampOffset();
        const fullPath = axios_1.default.getUri(config);
        const urlWithoutSuffix = fullPath.startsWith("https") ? fullPath.slice(8) : fullPath;
        const hostEndPos = urlWithoutSuffix.indexOf("/");
        const urlParamWithoutHost = urlWithoutSuffix.slice(hostEndPos);
        config.headers["Timestamp"] = timestamp;
        config.headers["Signature"] = (0, encrypt_1.hmac)(`${config.method}${urlParamWithoutHost}${body}${timestamp}`, secret);
        return config;
    }
    function processResp($observable, params) {
        const { needProcessResp = true } = params;
        if (needProcessResp) {
            return (0, Tools_1.resolveResponse)($observable);
        }
        else {
            return $observable;
        }
    }
    /**
     * 内部网络请求入口
     * @param method
     * @param params
     * @private
     */
    function request(method, params) {
        return getRequiredTokenInfo(params).pipe((0, operators_1.mergeMap)((tokenInfo) => {
            let headers = {};
            if (params.headers) {
                headers = Object.assign({}, params.headers);
            }
            if (!headers["Content-Type"]) {
                headers["Content-Type"] = "application/json";
            }
            let config = {
                method: method,
                url: params.url,
                headers: headers,
            };
            let body = "";
            if (!noBodyMethod.includes(method) && params.data) {
                if (typeof params.data !== "string" && headers["Content-Type"] === "application/json") {
                    // 因为签名时需要使用body参与计算，所以这里将body转换为字符串，保证传输的body内容和参与签名的body内容一致
                    // 如果params.data不是一个json对象，需要手动指定header的Content-Type
                    body = JSON.stringify(params.data);
                }
                else {
                    body = params.data;
                }
                config.data = body;
            }
            config = configParams(config, params);
            config = configAuthorization(config, params, tokenInfo);
            config = configSignature(config, params, tokenInfo, body);
            let $observable = (0, rxjs_1.from)(axios_1.default.request(config));
            $observable = (0, Tools_1.processRespFirst)($observable);
            $observable = processResp($observable, params);
            return $observable;
        }));
    }
    /**
     * 专门用于CDN数据请求
     */
    function getCDN(url) {
        const header = {
            "Cache-Control": "max-age=0",
            "Content-Type": "application/json;charset=UTF-8",
        };
        return (0, rxjs_1.from)(axios_1.default.get(url, { headers: header })).pipe((0, operators_1.map)((response) => response.data));
    }
    Network.getCDN = getCDN;
    function get(params) {
        return request("GET", params);
    }
    Network.get = get;
    function post(params) {
        return request("POST", params);
    }
    Network.post = post;
    function put(params) {
        return request("PUT", params);
    }
    Network.put = put;
    function delete$(params) {
        return request("DELETE", params);
    }
    Network.delete$ = delete$;
    /**
     * 设置通用请求头
     */
    function setCommonHeader(key, val) {
        axios_1.default.defaults.headers.common[key] = val;
    }
    Network.setCommonHeader = setCommonHeader;
})(Network || (exports.Network = Network = {}));
